//--------------------------------------------------------------------------------
/** 
 * Format a decimal number as a string
 * @param value The number to format
 * @param decimals The number of decimal places to display (eg 2 for dollars and cents)
 * @param zeroPadDecimals Zero-pad the decimal digits as needed (eg 1.5000)
 * @returns The formatted string
 */
export function formatDecimal(
  value: number | string | null | undefined,
  decimals = -1,
  zeroPadDecimals = false
) {
  if (value === null || value === undefined) return undefined
  if (typeof value === 'string')
    value = Number(value)
  let text = decimals === -1
    ? value.toLocaleString('en-US', {
      useGrouping: true,
    })
    : value.toLocaleString('en-US', {
      useGrouping: true,
      maximumFractionDigits: decimals,
      minimumFractionDigits: zeroPadDecimals ? decimals : 0,
    })
  return text
}

//--------------------------------------------------------------------------------
/** 
 * Convert an ISO 8601 date string (2026-04-18) to a Date object at 
 * midnight local time
 */
export function asLocalDate(value: string | null | undefined) {
  if (value === null || value === undefined) return undefined
  const parts = value.split('T')[0]?.split('-')
  if (!parts || parts.length < 3) return undefined
  return new Date(+parts[0]!, +parts[1]! - 1, +parts[2]!)
}

//--------------------------------------------------------------------------------
export function toFullDate(value: Date | string | null | undefined) {
  if (value === null || value === undefined) return undefined
  if (typeof value === 'string')
    value = new Date(value)
  return value.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  })
}

//--------------------------------------------------------------------------------
export function toShortDate(value: Date | string | null | undefined) {
  if (value === null || value === undefined) return undefined
  if (typeof value === 'string')
    value = new Date(value)
  return value.toLocaleDateString('en-US', {
    year: '2-digit',
    month: 'numeric',
    day: 'numeric',
  })
}
